import React, { createContext, useState } from 'react'

import { isFunction } from 'lodash'

import AssistantInfo from '../Components/MACCS/Internships/AssistantInfo'
import MaccsInternshipInfo from '../Components/shared/MaccsInternshipInfo'
import InternshipRejectionModal from '../Components/MACCS/InternshipsManager/InternshipRejectionModal'
import MaccsInternshipValidation from '../Components/shared/ShiftsManager/MaccsInternshipValidation/MaccsInternshipValidation'

export const MaccsInternshipsContext = createContext()
const DEFAULT_INTERNSHIP = { data: null, action: null, callback: () => {} }

const MaccsInternshipsProvider = ({ children }) => {
  const [highlightedIndexes, setHighlightedIndexes] = useState(null)
  const [selectedInternship, setSelectedInternship] = useState(DEFAULT_INTERNSHIP)
  const [selectedAssistant, setSelectedAssistant] = useState(null)

  const handleSelectInternship = (internship, action, callback) => {
    setSelectedInternship({ data: internship, action, callback: isFunction(callback) ? callback : () => {} })
    setSelectedAssistant(null)
  }

  const handleSelectAssistant = assistant => {
    setSelectedAssistant(assistant)
    setSelectedInternship(DEFAULT_INTERNSHIP)
  }

  const handleCallback = () => {
    if (isFunction(selectedInternship.callback)) {
      selectedInternship.callback()
    }

    setSelectedInternship(DEFAULT_INTERNSHIP)
  }

  return (
    <>
      <MaccsInternshipsContext.Provider value={{
        highlightedIndexes,
        setHighlightedIndexes,
        setInternshipInfo: (internship, callback) => handleSelectInternship(internship, 'INFO', callback),
        setInternshipToDelete: (internship, callback) => handleSelectInternship(internship, 'REFUSE', callback),
        setSelectedAssistant: handleSelectAssistant
      }}
      >
        {children}
      </MaccsInternshipsContext.Provider>
      <AssistantInfo assistant={selectedAssistant} onClose={() => setSelectedAssistant(null)} />
      <MaccsInternshipInfo
        maccsInternship={selectedInternship.action === 'INFO' ? selectedInternship.data : null}
        onClose={() => setSelectedInternship(DEFAULT_INTERNSHIP)}
        onMaccsInternshipValidate={handleCallback}
      />
      <InternshipRejectionModal
        internship={selectedInternship.action === 'REFUSE' ? selectedInternship.data : null}
        onClose={isRefused => isRefused ? handleCallback() : setSelectedInternship(DEFAULT_INTERNSHIP)}
      />
      {selectedInternship.action === 'VALIDATE' && (
        <MaccsInternshipValidation
          maccsInternship={selectedInternship.data}
          onClose={() => setSelectedInternship(DEFAULT_INTERNSHIP)}
          onValidate={handleCallback}
          onInvalidate={handleCallback}
          bottom
        />
      )}
    </>
  )
}

export default MaccsInternshipsProvider
